var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',_vm._b({attrs:{"value":_vm.value},on:{"input":_vm.handleChange}},'el-date-picker',Object.assign({}, _vm.defaultAttrs,
      _vm.attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }